/**
 * Presentation-only URL helpers for the governed full-page source viewer.
 * Viewer state is resolved from backend-issued governedSession tokens only.
 */

export type GovernedSourceViewNavigation = {
  cognitoryId: string;
  documentId: string;
  documentVersionId: string;
  documentTitle: string;
  citationNumber: string;
  pageNumber: number;
  citedPassage: string;
};

const GOVERNED_SESSION_QUERY_PARAM = "governedSession" as const;

export function buildGovernedSourceViewPath(
  cognitoryId: string,
  sessionToken?: string,
): string {
  const base = `/cognitory/${encodeURIComponent(cognitoryId)}/source`;
  if (!sessionToken) {
    return base;
  }
  const params = new URLSearchParams({
    [GOVERNED_SESSION_QUERY_PARAM]: sessionToken,
  });
  return `${base}?${params.toString()}`;
}

export function readGovernedSessionTokenFromLocation(
  search: string,
): string | null {
  const token = new URLSearchParams(search).get(GOVERNED_SESSION_QUERY_PARAM);
  if (!token || token.trim().length === 0) {
    return null;
  }
  return token;
}

export function toGovernedSourceViewNavigation(input: {
  cognitoryId: string;
  citationNumber: string;
  documentId: string;
  documentVersionId: string;
  documentTitle: string;
  pageNumber: number;
  citedPassage: string;
}): GovernedSourceViewNavigation {
  return {
    cognitoryId: input.cognitoryId,
    documentId: input.documentId,
    documentVersionId: input.documentVersionId,
    documentTitle: input.documentTitle,
    citationNumber: input.citationNumber,
    pageNumber: input.pageNumber,
    citedPassage: input.citedPassage,
  };
}
